import { CaretRightFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import { FormikErrors } from 'formik';
import * as React from 'react';
import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import { allErrors } from './allErrors';

const FormErrorsList = styled.div`
  margin-bottom: 0;
  margin-top: 12px;
  p {
    margin-bottom: 8px;
  }
`;

type ModalType = ReturnType<typeof Modal['error']>;

export interface IErrorNotificationModalProps {
  submitCount: number;
  errors: FormikErrors<unknown>;
}

/**
 * Modal di errore mostrata per elencare gli erorri di validazione.
 */
export function ErrorNotificationModal(props: IErrorNotificationModalProps) {
  const { submitCount, errors } = props;
  const submitCountRef = React.useRef(0);
  const modal = React.useRef<ModalType | undefined>();

  useLayoutEffect(() => {
    if (submitCount > 0 && submitCount !== submitCountRef.current) {
      submitCountRef.current = submitCount;
      if (Object.keys(errors).length > 0) {
        if (modal.current) {
          modal.current.destroy();
        }

        modal.current = Modal.error({
          title: 'Errore di Validazione',
          width: 700,
          onOk() {
            // Fix per gestire la proprietà di `overflow: hidden` che viene
            // impostata erroneamente
            try {
              document.body.style.removeProperty('overflow');
            } catch (e: any) {}
          },
          content: (
            <FormErrorsList>
              {allErrors(errors).map((error, i) => (
                <p key={i}>
                  <CaretRightFilled /> {error}
                </p>
              ))}
            </FormErrorsList>
          )
        });
      }
    }

    return () => {
      if (modal.current) modal.current.destroy();
    };
  }, [submitCount, errors]);

  return null;
}
